import { Vue, Component } from 'vue-property-decorator'

@Component
export default class GrossingTouchSidebar extends Vue {
    private sidebarContent !: Array<object>

    constructor() {
        super()
        this.sidebarContent = [
            {
                section: this.$tc('grossing.sidebar.pendingSamples'),
                elements: [
                    {
                        title: this.$tc('grossing.sidebar.forGrossing'),
                        icon: 'far fa-scalpel-path',
                        active: true,
                        bubble: 3
                    },
                    {
                        title: this.$tc('grossing.sidebar.forRegrossing'),
                        icon: 'icon-scalpel-reload',
                        active: false,
                        bubble: 0
                    },
                    {
                        title: this.$tc('grossing.sidebar.forTakeOut'),
                        icon: 'far fa-inbox-out',
                        active: false,
                        bubble: 0
                    },
                    {
                        title: this.$tc('grossing.sidebar.forFiling'),
                        icon: 'far fa-inbox-in',
                        active: false,
                        bubble: 1
                    }
                ]
            },
            {
                section: this.$tc('grossing.sidebar.shelves'),
                elements: [
                    {
                        title: this.$tc('grossing.sidebar.immediate'),
                        icon: 'far fa-exclamation-circle',
                        active: false,
                        bubble: 42
                    },
                    {
                        title: this.$tc('grossing.sidebar.intermediate'),
                        icon: 'far fa-minus-circle',
                        active: false,
                        bubble: 0
                    },
                    {
                        title: this.$tc('grossing.sidebar.delayed'),
                        icon: 'far fa-pause-circle',
                        active: false,
                        bubble: 4
                    },
                    {
                        title: this.$tc('grossing.sidebar.autopsies'),
                        icon: 'far fa-user-tag',
                        active: false,
                        bubble: 0
                    }
                ]
            },
            {
                section: this.$tc('grossing.sidebar.grossedSamples'),
                elements: [
                    {
                        title: this.$tc('grossing.sidebar.grossingToday'),
                        icon: 'far fa-calendar-day',
                        active: false,
                        bubble: 0
                    },
                    {
                        title: this.$tc('grossing.sidebar.grossingThisWeek'),
                        icon: 'far fa-calendar-week',
                        active: false,
                        bubble: 0
                    },
                    {
                        title: this.$tc('grossing.sidebar.grossingThisMonth'),
                        icon: 'far fa-calendar-alt',
                        active: false,
                        bubble: 0
                    }
                ]
            }
        ]
    }
}
